import PageTabsCL from './PageTabsCL';

export default PageTabsCL;
